import {useEffect, useState} from 'react';

function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (typeof value === 'string') {
        // Allow empty string to propagate (for clear/reset)
        if (value.trim().length > 2 || value === '') {
          setDebouncedValue(value);
        }
        // Otherwise, ignore (keep old debounced value)
      } else {
        // For non-string values, always update
        setDebouncedValue(value);
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
